import { render, staticRenderFns } from "./ResultsDetailNavigation.vue?vue&type=template&id=4bc1c9a0"
import script from "./ResultsDetailNavigation.vue?vue&type=script&lang=js"
export * from "./ResultsDetailNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-load_3fdf6772527016f1099ec355f527a90f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports